export const SET_FLIGHT_BLOCK = 'FLIGHT_BLOCKS/SET_FLIGHT_BLOCK'
export const SET_FLIGHT_BLOCKS = 'FLIGHT_BLOCKS/SET_FLIGHT_BLOCKS'
